module.exports = __webpack_public_path__ + "img/logo-flat.a7477887.svg";